import React from 'react';
import ShopThumb, { Props as ShopThumbProps } from './ShopThumb';
import { commissionAdapter, premiumContentAdapter } from './Adapters';
import { ShopThumbType } from './types';

// Transform deviation into ShopThumb props depending on the deviation type
export interface Props extends ShopThumbProps {
  type?: ShopThumbType;
}
const ShopThumbFactory: React.FC<Props> = ({ type, ...props }) => {
  let adapterType: ShopThumbType | undefined = undefined;
  if (type) {
    adapterType = type;
  } else {
    if (props.deviation.hasOwnProperty('commission')) {
      adapterType = ShopThumbType.COMMISSION;
    } else if (props.deviation.hasOwnProperty('pcp')) {
      adapterType = ShopThumbType.PCP;
    }
  }
  let shopThumbProps: ShopThumbProps;
  switch (adapterType) {
    case ShopThumbType.COMMISSION:
      shopThumbProps = commissionAdapter(props);
      break;
    case ShopThumbType.PCP:
      shopThumbProps = premiumContentAdapter(props);
      break;
    default:
      shopThumbProps = props;
  }
  return <ShopThumb {...shopThumbProps} />;
};

export default ShopThumbFactory;
